import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import messages from './ReturnToInvestors.intl';
import LanguageService from 'services/Language.service';
import { ANCHOR } from '../../../common/consts/common';

import styles from './ReturnToInvestors.module.scss';

@injectIntl
export default class ReturnToInvestors extends Component {
  //TO DO translations, differend path
  language = LanguageService.getLang();
  render() {
    return (
      <div className={styles.returnDivContainer}>
        <i className={styles.ArrowLeft} />
        <Link
          to={ANCHOR.FOR_INVESTORS[this.language]}
          className={styles.Return}
        >
          {this.props.intl.formatMessage(messages.back)}
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ReturnToInvestors/ReturnToInvestors.js